import './Admissions_consultant_content.scss';
// import * as S from '../../scss/theme';
// import fnc from '../../mymod/commFunction';
// import HongButton from '../../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const Admissions_consultant_content = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
//=========================================
  return (

<div className='Admissions_consultant_content'>
  <div className='contract-box'>
    <p className='title'>아이공 입시컨설턴트 운용계약서</p>
    <div className='contract-text'>
      <p>□ 아이공에서 제공하는 [입시코칭ㅣ컨설팅] 관련 다음과 같은 내용으로 계약한다.</p>
      <br />
      <p>1. (입시코칭ㅣ컨설팅 기간) 신청 후 3개월 內로 진행하는 것을 원칙으로 하며,<br />
         3~6회 남짓의 대면 및 비대면으로 진행하는 것을 목표로 한다. (비대면 컨설팅이 기준임)</p>
      <br />
      <p>2. (자동배치) 신청자의 지역 및 희망 입시전략 구분에 따라
         당사에서 기준하는 자동배치를 원칙으로 한다.</p>
      <br />
      <p>3. (운용방식)</p>
      <p>  1차 : 자동배치 완료 시, 전화상담을 통해 필요로하는 내용 관련 직접 협의완료.</p>
      <p>  2차 : 이후 3~6회에 걸쳐 대면 및 비대면의 방식으로 자율진행.</p>
      <p>  3차 : 코칭ㅣ컨설팅 시, 날짜 및 내용 등 간단한 정보 입력 완료.</p>
      <p>  4차 : 최종 완료 시 종료버튼 클릭. (종료 후 비용정산 진행)</p>
      <br />
      <p>4. (비용정산) 해당 신청금액 기준, VAT를 제외한 총 신청금액 中 65%에 해당하는 비용을
         입시코칭ㅣ컨설팅 완료 후 7일 內 정산한다. (비용구분 : 아래 도표 참조)</p>
      <br />
      <p>5. (환불조건) 신청자의 요청에 의해 중도 해지/환불 시
         총 6회 입시코칭ㅣ컨설팅 기준으로 회당비용으로 환산/분할하여 환불처리한다.<br />
         잔여 매출금액 기준으로 65%에 해당하는 비용을 정산한다.</p>
      <br />
      <p>위 내용을 확인하셨습니까? <br />미 동의 시, 아이공 입시컨설턴트 운용계약은 불가 합니다.</p>
      {/* <p>  □ 동의  □ 미동의</p> */}
      <br />
      <p>동의한 분들에 한해 아래 기초정보를 입력해 주시길 바랍니다.</p>
    </div>
  </div>
</div>


  );
};

export default Admissions_consultant_content;